import React from "react";
import { Coffee } from "lucide-react";
import ExternalLink from "./ExternalLink";

const COFFEE_URL = "https://buymeacoffee.com/ojadventures";

/**
 * Buy Me a Coffee floating action button.
 * Uses <ExternalLink> so the click reliably opens in a new tab without navigating
 * the host iframe away from the app.
 */
export default function CoffeeFAB() {
  return (
    <ExternalLink
      href={COFFEE_URL}
      testid="coffee-fab"
      aria-label="Support the app — buy Ozzy a coffee"
      className="
        fixed z-[1001] bottom-24 right-4 sm:right-6
        flex items-center gap-2
        bg-[#FFDD00] text-black
        rounded-full shadow-lg ring-1 ring-black/10
        h-12 w-12 sm:w-auto sm:px-5
        justify-center sm:justify-start
        font-medium text-sm
        hover:brightness-95 active:scale-95 transition
        focus-visible:outline-none focus-visible:ring-4 focus-visible:ring-[#FFDD00]/40
      "
    >
      <Coffee size={20} strokeWidth={2.2} className="shrink-0" />
      <span className="hidden sm:inline whitespace-nowrap">Support the app</span>
    </ExternalLink>
  );
}
